// export const SERVER_URL = 'http://localhost:8081/api/';
export const SERVER_URL = 'https://api.jevebara.com/api/';